/* =========================================================
   Cup Sizes — reveal observer + light interactions
   ========================================================= */

(function () {
  'use strict';

  function initCupSizes(root) {
    if (!root || root.dataset.csInit === 'true') return;
    root.dataset.csInit = 'true';

    // ---------- Reveal on scroll ----------
    const revealEls = root.querySelectorAll('.reveal');

    if ('IntersectionObserver' in window && revealEls.length) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in');
              io.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -50px 0px',
        }
      );
      revealEls.forEach((el) => io.observe(el));
    } else {
      revealEls.forEach((el) => el.classList.add('in'));
    }
  }

  function initAll() {
    document.querySelectorAll('.cs[data-section-id]').forEach(initCupSizes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.cs[data-section-id]');
    if (root) initCupSizes(root);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector('.cs[data-section-id]');
    if (root) root.dataset.csInit = '';
  });
})();
